import { render, staticRenderFns } from "./PreRecordedCustoms.vue?vue&type=template&id=20b5026a&scoped=true&"
import script from "./PreRecordedCustoms.vue?vue&type=script&lang=js&"
export * from "./PreRecordedCustoms.vue?vue&type=script&lang=js&"
import style0 from "./PreRecordedCustoms.vue?vue&type=style&index=0&id=20b5026a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b5026a",
  null
  
)

export default component.exports